<div class="report-viewer-container">
    @if (data.type === 'Warnings' && data.data.warnings.length !== 0) {
        <h1>Avertissements</h1>
        @for (warning of data.data.warnings; track warning) {
            <div class="report-viewer-message">
                <fa-icon [icon]="warningIcon" class="warning-icon"></fa-icon>
                <span>{{ warning.message }}</span>
                @if (warning.sourceId) {
                    <a
                        class="goto-icon"
                        (click)="goto(warning.sourceType, warning.sourceId)"
                        matTooltip="Se rendre sur l'élément à l'origine de l'avertissement"
                        matTooltipPosition="below">
                        <fa-icon [icon]="gotoIcon"></fa-icon>
                    </a>
                }
            </div>
        }
    }
    @if (data.type === 'Errors' && data.data.errors.length !== 0) {
        <h1>Erreurs</h1>
        @for (error of data.data.errors; track error) {
            <div class="report-viewer-message">
                <fa-icon [icon]="errorIcon" class="error-icon"></fa-icon>
                <span>{{ error.message }}</span>
                @if (error.sourceId) {
                    <a class="goto-icon" (click)="goto(error.sourceType, error.sourceId)" matTooltip="Se rendre sur l'élément à l'origine de l'erreur" matTooltipPosition="below">
                        <fa-icon [icon]="gotoIcon"></fa-icon>
                    </a>
                }
            </div>
        }
    }
</div>
